var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 388.74 388.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    y2: 414.36,
    gradientUnits: "userSpaceOnUse",
    x2: 353.75,
    gradientTransform: "matrix(2.5278 2.5256 -2.5278 2.5256 565.91 -1456.1)",
    y1: 414.36,
    x1: 335.72
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.827,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    y2: 437.79,
    gradientUnits: "userSpaceOnUse",
    x2: 365.75,
    gradientTransform: "matrix(2.5278 2.5256 -2.5278 2.5256 565.91 -1456.1)",
    y1: 437.79,
    x1: 331.72
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdd7c",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y2: 318.69,
    gradientUnits: "userSpaceOnUse",
    x2: 185.48,
    gradientTransform: "matrix(2.3454 2.3434 -2.3454 2.3434 888.99 -800.77)",
    y1: 318.69,
    x1: 148.7
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9191",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b55858",
    offset: 1
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M567.38 303.44c-23.74-23.72-49.66-36.33-57.82-28.18-.55.55-1.03 1.17-1.4 1.88l-51.66 51.62 7.8 7.79 30.34 30.31 9.74 9.74 38.14 38.11 53.37-53.32c-.03-.1-.03-.21-.06-.31l-.06-.06.06-.06c7.68-8.4-4.93-34.03-28.45-57.52z",
    style: {
      color: "#000"
    },
    fill: "url(#a)",
    transform: "translate(-209.34 -272.78)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m470.45 314.82-48.31 48.27-5.54 5.54 7.79 7.79 78.23 78.16 53.85-53.81-43.01-42.98-35.21-35.18-7.8-7.79z",
    style: {
      color: "#000"
    },
    fill: "#e3dedb",
    transform: "translate(-209.34 -272.78)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000"
    },
    d: "m538.99 418.24-86.02-85.95-3.9 3.9-1.95 1.94 86.02 85.95 1.95-1.95 3.9-3.89zM548.74 408.5l-86.03-85.95-3.9 3.9-1.94 1.95 86.02 85.94 1.95-1.95 3.9-3.89zM529.24 427.98l-86.02-85.95-3.9 3.9-1.95 1.94 86.02 85.95 1.95-1.95 3.9-3.89z",
    transform: "translate(-209.34 -272.78)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m429.21 356.03-184.9 184.74-34.97 120.88 10.96-3.16 110.03-31.77 184.9-184.74-16.69-16.68-5.85-5.84-15.6-15.59-1.95-1.94-5.85-5.85-1.95-1.95-15.59-15.58-5.85-5.84-8.9-8.89-7.79-7.79z",
    style: {
      color: "#000"
    },
    fill: "url(#b)",
    transform: "translate(-209.34 -272.78)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000"
    },
    d: "m256.88 647.93-16.9-16.89-16.9-16.89-13.74 47.5 47.54-13.72z",
    transform: "translate(-209.34 -272.78)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.83 361.08c.03.1.03.21.06.31l.12-.13-.18-.18z",
    style: {
      color: "#000"
    },
    fill: "#ff9191",
    transform: "translate(-209.34 -272.78)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m429.21 356.03-184.9 184.74 41.73 1.28 1.28 41.69 41.73 1.28 1.28 41.7 184.9-184.74-21.51-21.49-21.5-21.49-21.51-21.48-21.5-21.49z",
    style: {
      color: "#000"
    },
    fill: "#ffc700",
    transform: "translate(-209.34 -272.78)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m429.21 356.03-184.9 184.74 41.73 1.28 164.67-164.53-21.5-21.49z",
    style: {
      color: "#000"
    },
    fill: "#ffda00",
    transform: "translate(-209.34 -272.78)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.05 585.02 1.28 41.7 184.9-184.74-21.51-21.49-164.67 164.53z",
    style: {
      color: "#000"
    },
    fill: "#ff8a00",
    transform: "translate(-209.34 -272.78)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.32 583.74 41.73 1.28 164.67-164.53-21.5-21.49-184.9 184.74z",
    style: {
      color: "#000"
    },
    fill: "#ffa100",
    transform: "translate(-209.34 -272.78)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.1 336.97c-1.55-1.55-3.37-2.77-5.29-3.55s-3.96-1.1-6-1.1c-2.05 0-4.09.32-6.01 1.1s-3.73 2-5.29 3.55l-29.23 29.2-173.55 173.4c-.54.54-.74 1.24-1.18 1.82l21.48.63 1.27 41.67 24.64.79 172.92-172.77 29.23-29.2c1.56-1.55 2.78-3.37 3.56-5.29.77-1.92 1.1-3.95 1.1-5.99 0-2.05-.33-4.08-1.1-6-.78-1.92-2-3.73-3.56-5.29l-22.99-22.97z",
    style: {
      color: "#000"
    },
    fill: "url(#c)",
    transform: "translate(-209.34 -272.78)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "m239.98 631.04-11.24-11.23-19.4 41.84 30.64-30.61z",
    style: {
      color: "#000"
    },
    fill: "#fff",
    transform: "translate(-209.34 -272.78)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.27ec3dfb5b0ce41efa474127c7b2b4f4.svg";
export { ForwardRef as ReactComponent };